import React from 'react'
import { useHistory } from 'react-router-dom'
import { Modal } from 'react-bootstrap'
import { Button, useUserService } from '@abroad/components'
import {
  gtmScheduleFirstSessionAction,
  gtmScheduleAllSessionAction,
} from '../quests/gtmfunctions'

const ScheduleGuidelineModal = ({
  show = false,
  handleClose = () => {},
  coachDetails,
  onScheduleAll = () => {},
  isFirstSessionScheduled = false,
}) => {
  const history = useHistory()
  const { user } = useUserService()

  const getSessionLabel = () => {
    const coachName =
      coachDetails?.coach?.fullName || coachDetails?.coach?.fname
    const clientName =
      coachDetails?.client?.fullName || coachDetails?.client?.fname
    if (coachName || clientName) {
      return `Coaching Plan: ${coachName || '-'} & ${clientName || '-'}`
    }
    return 'Coaching Plan'
  }

  const navigateToScheduling = () => {
    if (isFirstSessionScheduled) {
      return
    }

    gtmScheduleFirstSessionAction(
      getSessionLabel(),
      user?._id,
      coachDetails?.questId,
    )

    history.push('/coaching/sessions/upcoming/first-session', {
      coachDetails,
    })
    handleClose()
  }

  const navigateToScheduleAll = () => {
    gtmScheduleAllSessionAction(
      getSessionLabel(),
      user?._id,
      coachDetails?.questId,
      coachDetails?.totalSessions || coachDetails?.remainingSessions,
    )

    history.push('/coaching/sessions/schedule-remaining', {
      coachDetails,
      useScheduleAll: true,
    })
    handleClose()
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size='lg'
      className='payment-modal payment-extra-width'
      dialogClassName='payment-modal-dialog  justify-content-center'>
      <Modal.Header className='payment-modal-header d-flex justify-content-center'>
        <h3 className='payment-modal-title mb-0 text-uppercase'>
          Scheduling Guideline
        </h3>
      </Modal.Header>
      <Modal.Body className='payment-modal-body'>
        <div className='s7 text-start'>
          Welcome! Let’s get your sessions on the calendar.
          <br />
          <br /> If you know your plan (e.g. biweekly or monthly), feel free to
          book them all now. Otherwise, simply schedule your first session and
          your coach will help you plan the rest.
        </div>
      </Modal.Body>
      <Modal.Footer className='border-0 d-flex justify-content-center gap-3 flex-row'>
        <Button
          variant='saffron'
          className='px-4 text-uppercase'
          size='sm'
          onClick={navigateToScheduling}
          disabled={isFirstSessionScheduled}>
          Schedule First Session
        </Button>
        <Button
          variant='secondary-light'
          className='px-4 text-uppercase secondary-popup-button'
          size='sm'
          onClick={navigateToScheduleAll}>
          Schedule Multiple Sessions
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ScheduleGuidelineModal
